module.exports = __webpack_public_path__ + "static/media/apropo_1.355b9992.jpg";